import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

const ImageSection = ({data, selectedColor}) => {
  const variants = data?.variants || [];

  const [zoomStyle, setZoomStyle] = useState({});

  const handleMouseMove = e => {
    const {left, top, width, height} = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomStyle({
      transformOrigin: `${x}% ${y}%`,
      transform: 'scale(2)',
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: 'scale(1)',
      transformOrigin: 'center',
    });
  };

  const selectedVariant =
    variants.find(v => v.color === selectedColor) || variants[0];

  const images = Array.isArray(selectedVariant?.images)
    ? selectedVariant.images
    : [];

  const [activeImage, setActiveImage] = useState('');

  /* Reset main image when color changes */
  useEffect(() => {
    if (images.length > 0) {
      setActiveImage(images[0]);
    } else {
      setActiveImage('');
    }
  }, [images, selectedColor]);

  if (!images.length) {
    return (
      <div className={'text-center text-gray-500'}>
        No images available
      </div>
    );
  }
  const toDropboxRawUrl = (url = '') =>
    url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
      .replace('?dl=0', '');
  return (
    <div className={'flex md:flex-row flex-col-reverse gap-4'}>

      {/* Thumbnails */}
      <div className={'flex md:flex-col gap-2 overflow-x-auto md:overflow-visible  scrollbar-hide'}>
        {images.map((img, index) => {
          const isActive = activeImage === img;

          return (
            <button
              key={`${img}-${index}`}
              type={'button'}
              onMouseEnter={() => setActiveImage(img)}
              onClick={() => setActiveImage(img)}
              className={`w-20 h-20 ml-2 flex-shrink-0 p-1 border border-[#DBDBDB] rounded-md focus:outline-none ${
                isActive ? 'border-primary-900' : 'border-gray'
              }`}
            >
              <img
                className={'w-full h-full object-cover rounded'}
                key={index}
                src={toDropboxRawUrl(img)}
                alt={`Product-${index}`}
              />
            </button>
          );
        })}
      </div>

      {/* Main Image */}
      <div
        className={
          `w-full h-[500px] md:rounded-lg overflow-hidden flex items-center justify-center ${
            zoomStyle.transform === 'scale(2)' ? 'cursor-zoom-in' : 'cursor-zoom-out'
          }`
        }
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={toDropboxRawUrl(activeImage)}
          alt={'Product'}
          style={zoomStyle}
          className={'w-full h-full md:rounded-lg object-contain transition-transform duration-200'}
        />
      </div>
    </div>
  );
};

ImageSection.propTypes = {
  data: PropTypes.object.isRequired,
  selectedColor: PropTypes.string,
};

export default ImageSection;
